import React from "react";
import { useTranslation, Trans } from "react-i18next";

// for styles
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core/";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";
import { dateFormat } from "../../utils/convert";

/**
 * 区間追加フライトの削除確認ダイアログ（issue #3015）。
 * DialogHotelCancel と同じスタイルパターンで「はい/いいえ」確認を出す。
 */
type Props = {
  isShow: boolean;
  date: string;             // 削除対象の搭乗日 YYYYMMDD
  order: number;            // 削除対象の order（2..n）
  callbackConfirm(order: number): void;
  callback: () => void;
};

const DialogAdditionalFlightCancel: React.FC<Props> = ({
  isShow,
  date,
  order,
  callbackConfirm,
  callback,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <Dialog
        open={isShow}
        onClose={callback}
        aria-labelledby="alert-dialog-additional-flight-cancel-title"
        aria-describedby="alert-dialog-additional-flight-cancel-description"
        className="dialog"
      >
        <DialogTitle id="alert-dialog-additional-flight-cancel-title" className="dialog-title">
          {t("追加区間の削除")}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-additional-flight-cancel-description" className="dialog-content-text">
            <Trans
              i18nKey={"$dateに追加した区間を削除してもよろしいですか？"}
              values={{ date: dateFormat(date, t("YYYY年MM月DD日"), i18n.language) }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className="button-dialog-border-small-blue w-110" onClick={callback}>
            {t("いいえ")}
          </Button>
          <Button
            className="button-dialog-small-blue w-110"
            onClick={() => callbackConfirm(order)}
            autoFocus
          >
            {t("はい")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogAdditionalFlightCancel;
